import { jsx } from "react/jsx-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import cn from "classnames";
import Box from "../Box";
import { useTheme } from "../ThemeProvider";
const DEFAULT_SIZE = "l";
const WRAPPER_SX = {
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10
};
const Spinner = (props) => {
  const currentTheme = useTheme();
  const iconSize = currentTheme.icon.size[props?.size ?? DEFAULT_SIZE];
  const classes = cn("spinner-wrapper", props.className);
  return /* @__PURE__ */ jsx(Box, { sx: WRAPPER_SX, color: props.color, className: classes, children: /* @__PURE__ */ jsx(CircularProgress, { disableShrink: true, size: `${iconSize}px`, color: "inherit" }) });
};
var Spinner_default = Spinner;
export {
  Spinner_default as default
};
